import { create } from 'evx';
import 'element-closest';
import Queue from './lib/Queue';
import Helpers from './lib/Helpers';
import vex from 'vex-js';
vex.registerPlugin(require('vex-dialog'));
vex.defaultOptions.className = 'vex-theme-plain';
vex.dialog.buttons.YES.className = 'btn';
vex.dialog.buttons.NO.className = 'btn btn--secondary';

const { detect } = require('detect-browser');

// import MethodCall from './components/MethodCall';
// import MegaMenu from './components/MegaMenu';
// import ClassChange from './components/ClassChange';
// import SlideToggle from './components/SlideToggle';
// import AddToCart from './components/AddToCart';
import Product from './components/Product';
// import NumberSelector from './components/NumberSelector';
// import Cart from './components/Cart';
// import StickyElem from './components/StickyElem';
import LoadMore from './components/LoadMore';
// import LockScroll from './components/LockScroll';
// import ObjectFit from './components/ObjectFit';
// import SideCart from './components/SideCart';
// import Quicklink from './components/Quicklink';
// import AjaxSearch from './components/AjaxSearch';
// import SetCSSVar from './components/SetCSSVar';
// import LazyLoad from './components/LazyLoad';
// import LazyLoadTrigger from './components/LazyLoadTrigger';
// import KeenSlider from './components/KeenSlider';
// import CountryProvinceSelector from './components/CountryProvinceSelector';
// import SlideToggleGroup from './components/SlideToggleGroup';

const components = {
  // 'lazy-load': LazyLoad,
  // 'lazy-load-trigger': LazyLoadTrigger,
  // 'set-css-var': SetCSSVar,
  // 'quicklink': Quicklink,
  // 'keen-slider': KeenSlider,
  'product': Product,
  // 'method-call': MethodCall,
  // 'mega-menus': MegaMenu,
  // 'class-change': ClassChange,
  // 'slide-toggle': SlideToggle,
  // 'toggle-group': SlideToggleGroup,
  // 'add-to-cart': AddToCart,
  // 'number-selector': NumberSelector,
  // 'cart': Cart,
  // 'sticky': StickyElem,
  'load-more': LoadMore
  // 'lock-scroll': LockScroll,
  // 'object-fit': ObjectFit,
  // 'side-cart': SideCart,
  // 'ajax-search': AjaxSearch,
  // 'country-province-selector': CountryProvinceSelector
};

const options = {};

const state = {
  eventQueue: new Queue(),
  ajaxCache: []
};

export default class Theme {
  constructor(ctx = state, passedOptions = {}) {
    this._options = { ...passedOptions, ...options };
    let themeInfoElem = document.querySelector('[data-theme-information]');
    if (themeInfoElem) {
      ctx = { ...ctx, ...JSON.parse(themeInfoElem.innerHTML) };
    }
    this._ctx = create(ctx);
    this._viewportEvent();
    this._bodyScrollListen();
    this._runHooks();
    this._browserDetect();
    this._components = [];
  }

  _browserDetect() {
    const browser = detect();
    if (browser) {
      document.body.classList.add(`browser--${Helpers.handleize(browser.name)}`);
      document.body.classList.add(`os--${Helpers.handleize(browser.os)}`);
    }
  }

  _viewportEvent() {
    window.addEventListener(
      'resize',
      () => {
        this._viewportLogic();
      },
      { passive: true }
    );
    this._viewportLogic();
  }

  _bodyScrollListen() {
    const targetNode = document.body;
    const config = { attributes: true, childList: false, subtree: false };

    const callback = function (mutationsList, observer) {
      document.documentElement.style.setProperty(
        '--scroll-gap-right',
        getComputedStyle(document.body).paddingRight
      );
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  _viewportLogic() {
    let vh = window.innerHeight * 0.01;
    let vw = document.body.clientWidth * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    document.documentElement.style.setProperty('--vw', `${vw}px`);
  }

  mountComponents(container = document) {
    console.log('Theme: mountComponents called', { container, components });
    for (let componentKey in components) {
      if (components.hasOwnProperty(componentKey)) {
        let selector = `[data-${componentKey}]`;
        let elements = container.querySelectorAll(selector);
        console.log(`Theme: Found ${elements.length} elements for ${componentKey}`, elements);
        for (let elem of elements) {
          this.mountComponent(componentKey, componentKey, elem);
        }
      }
    }
    window.__Theme = this;
    window.__ThemeComponents = this._components;

    this._ctx.emit('radiant--mounted');
  }

  unmountComponents(container = document) {
    for (var i = this._components.length - 1; i >= 0; i--) {
      let component = this._components[i];

      if (container.contains(component.elem)) {
        let componentObj = component.component;
        if (typeof componentObj.unmount === 'function') {
          componentObj.unmount();
        }
        component = null;
        componentObj = null;
        this._components.splice(i, 1);
      }
    }
  }

  mountComponent(type, dataAttr, elem) {
    try {
      let optionStr = elem.getAttribute(`data-${dataAttr}`).trim();
      let options = {};
      if (optionStr.startsWith('{') || optionStr.startsWith('[')) {
        options = JSON.parse(optionStr);
      }
      let compInstance = new components[type](elem, this, options, this._ctx);
      this._components.push({
        type: type,
        elem: elem,
        id: compInstance._options.id,
        component: compInstance
      });
      compInstance.mount();
    } catch (e) {
      console.error(`-----ERROR IN COMPONENT----- \ntype: ${type}\nelement and stack trace below:`);
      console.error(elem);
      console.error(e);
    }
  }

  getOptions() {
    return this._options;
  }

  getComponent(id) {
    return this._components.find((component) => component.id === id);
  }

  getComponentByElem(elem) {
    return this._components.find((component) => component.elem === elem);
  }

  _runHooks() {
    this._ctx.on('cart-item-added', (state) => {
      if (window.pintrk) {
        pintrk('track', 'addtocart', {
          value: state.lastItemAdded.item.price / 100.0,
          order_quantity: state.lastItemAdded.quantity
        });
      }
      if (window.fbq) {
        fbq('track', 'AddToCart');
      }
    });
  }
}
